module.exports = __webpack_public_path__ + "img/01.379c42ca.png";